import { Container } from './styles'
import ScrollAnimationWrapper from '../helpers/ScrollAnimationWrapper'
import 'animate.css/animate.min.css'
interface HeaderTitleProps {
  title: string
  description?: string
  descriptionAlign?: 'start' | 'center'
  titleAlign?: 'start' | 'center'
  href?: string
  fancyText?: boolean
  fancyTextBgColor?: string
}

export function HeaderTitle({
  title,
  description,
  descriptionAlign,
  titleAlign,
  href,
  fancyText = false,
  fancyTextBgColor
}: HeaderTitleProps) {
  return (
    <ScrollAnimationWrapper animateIn="animate__fadeInDown">
      <Container
        descriptionAlign={descriptionAlign}
        titleAlign={titleAlign}
        fancyText={fancyText}
        fancyTextBgColor={fancyTextBgColor}
      >
        {href ? (
          fancyText ? (
            <a href={href} target="_blank">
              <div className="fancy-text-container">
                <div className="fancy-text-bg" />
                <h2>{title}</h2>
              </div>
            </a>
          ) : (
            <a href={href} target="_blank">
              <h2>{title}</h2>
            </a>
          )
        ) : fancyText ? (
          <div className="fancy-text-container">
            <div className="fancy-text-bg" />
            <h2 className="fancy-text">{title}</h2>
          </div>
        ) : (
          <h2>{title}</h2>
        )}
        <p>{description}</p>
      </Container>
    </ScrollAnimationWrapper>
  )
}

